// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";

export const fetchCountries = async (setCountries, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-country/`
    );
    if (response.ok) {
      const data = await response.json();
      setCountries(data); // Update state with fetched countries
    } else {
      message.error("Failed to fetch countries.");
    }
  } catch (error) {
    message.error("An error occurred while fetching countries.");
  }
};